export default function () {
  const routesModules = require.context('@/store/modules/', true, /\.(js)$/);
  return routesModules.keys().reduce((acc, key) => {
    const importedRoutes = routesModules(key).default;
    return { ...acc, [importedRoutes.name]: importedRoutes };
  }, {});
}
